module.exports = __webpack_public_path__ + "static/assets/79ac0ae1c38b63f455319abb5db98860.png";